import $ from "../../../libs/jquery-3.3.1.min.js"
import {gsap} from "../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras'
import {BaseMiniGame} from "./BaseMiniGame";
import {TranslatableText} from "./components/TranslatableText";
import {Bubble} from "./components/Bubble";
import {InteractiveButton} from "./components/InteractiveButton";
import {LanguageSwitcher} from "./components/LanguageSwitcher";

export class IdleScreen extends BaseMiniGame {

  // Constructor
  constructor(data) {
    super(data);
    this.appWidth = this.data.appDimensions.width;
    this.appHeight = this.data.appDimensions.height;

    this.backgroundSprite = null;
    this.progression = 1;

    this.textTitleStyle = new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 192,
      fontWeight: 500,
      lineHeight: 160,
      align: "left",
      fill: "#343B6F",
    });
    this.textParagraphStyle = new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 38,
      fontWeight: 400,
      lineHeight: 54,
      align: "left",
      fill: "#343B6F",
      wordWrap: true,
      wordWrapWidth: 1020
    });

    this.buttonSize = 560;
    this.buttonTextStyle = new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 72,
      fontWeight: 600,
      align: "left",
      fill: "#343B6F",
    });
  }

  async assetLoader() {
    // Game related assets
    if (this.data.medias && this.data.medias.length) {
      for (let i = 0; i < this.data.medias.length; i++) {
        this.assets[this.data.medias[i].name] = await PIXI.Assets.load(this.data.medias[i].url);
      }
    }

    // Global assets
    if (app.data.global.medias && app.data.global.medias.length) {
      for (let i = 0; i < app.data.global.medias.length; i++) {
        this.assets[app.data.global.medias[i].name] = await PIXI.Assets.load(app.data.global.medias[i].url);
      }
    }
  }

  async buildStage() {
    this.mainContainer = new PIXI.Container();
    this.stage.addChild(this.mainContainer);

    this.buildText();
    this.buildBackground();

    // Build buttons
    this.buildTransportButton();
    this.buildAlimentationButton();
    this.buildNatureButton();

    this.buildSoundscape();

    // Add language switcher
    this.languageSwitcher = new LanguageSwitcher(this);
    this.stage.addChild(this.languageSwitcher);

    this.buildOverlay();

    //add listener
    this.ticker.add(this.progress.bind(this));
  }

  buildText() {
    const textContainer = new PIXI.Container();
    textContainer.position.x = 630;
    textContainer.position.y = 665;
    this.stage.addChild(textContainer);

    const titleTextEN = new TranslatableText(this.data.title.en, this.textTitleStyle, "en", this).getText();
    const titleTextFR = new TranslatableText(this.data.title.fr, this.textTitleStyle, "fr", this).getText();

    const paragraphTextEN = new TranslatableText(this.data.text.en, this.textParagraphStyle, "en", this).getText();
    const paragraphTextFR = new TranslatableText(this.data.text.fr, this.textParagraphStyle, "fr", this).getText();
    paragraphTextEN.position.set(0, titleTextEN.height + 35);
    paragraphTextFR.position.set(0, titleTextFR.height + 35);

    textContainer.addChild(titleTextEN);
    textContainer.addChild(titleTextFR);
    textContainer.addChild(paragraphTextEN);
    textContainer.addChild(paragraphTextFR);
  }

  buildBackground() {
    this.backgroundSprite = new PIXI.Sprite(this.assets.background);
    this.mainContainer.addChild(this.backgroundSprite);

    // Earth shadow
    const earthShadow = new PIXI.Sprite(this.assets.earth_shadow);
    earthShadow.setSize(2076, 2076);
    earthShadow.position.set(1464, -200);
    earthShadow.anchor.set(0.5, 0.5);
    this.mainContainer.addChild(earthShadow);

    // Earth
    const earth = new PIXI.Sprite(this.assets.earth_warming);
    earth.setSize(1600, 1600);
    earth.position.set(1478, -314);
    earth.anchor.set(0.5, 0.5);
    this.mainContainer.addChild(earth);

    // Sun
    const sun = new PIXI.Sprite(this.assets.sun);
    sun.setSize(3214, 3142);
    sun.position.set(4200, 1080);
    sun.anchor.set(0.5, 0.5);
    this.mainContainer.addChild(sun);

    // Bubbles
    this.bubbles = [
      new Bubble(-498, 496, 824, 0xFF995A, this.progression, this), // orange
      new Bubble(1754, 1844, 170, 0xF6E4DD, this.progression, this), // white
      new Bubble(3184, 628, 68, 0xFF6463, this.progression, this), // red
      new Bubble(3584, 1528, 28, 0xFF9959, this.progression, this), // red
    ];
    for (let i = 0; i < this.bubbles.length; i++) {
      this.mainContainer.addChild(this.bubbles[i]);
    }

    // Animations
    this.backgroundTimeline = gsap.timeline();
    this.backgroundTimeline.to(earth, {duration: 75.0, rotation: Math.PI * 2, ease: 'linear', repeat: -1}, 0.0);
    this.backgroundTimeline.to(earthShadow.scale, {duration: 2.0, x: 1.25, y: 1.25, ease: 'sine.inOut', yoyo: true, repeat: -1}, 0.0);
    this.backgroundTimeline.to(sun.scale, {duration: 2.0, x: 1.35, y: 1.35, ease: 'sine.inOut', yoyo: true, repeat: -1}, 0.0);
  }

  buildTransportButton() {
    const buttonContainer = new InteractiveButton((e) => {
      app.switchGame(1)
    }, true, "audio/MAF_Reactif_Bouton_Zone 1.oga");

    buttonContainer.position.set(2279, 623);
    this.stage.addChild(buttonContainer);

    // Text
    const buttonTextEN = new TranslatableText(this.data.buttons.transport_text.en.toUpperCase(), new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 58,
      fontWeight: 600,
      align: "left",
      fill: "#343B6F",
    }), "en", this).getText();
    const buttonTextFR = new TranslatableText(this.data.buttons.transport_text.fr.toUpperCase(), this.buttonTextStyle, "fr", this).getText();
    buttonTextEN.anchor.set(0.5);
    buttonTextFR.anchor.set(0.5);
    buttonTextEN.position.set(this.buttonSize / 2, this.buttonSize / 2);
    buttonTextFR.position.set(this.buttonSize / 2, this.buttonSize / 2);

    // Arrow
    const arrow = new PIXI.Sprite(this.assets.arrow_right);
    arrow.setSize(50, 30);
    arrow.anchor.set(0.5, 0.5);
    arrow.position.set(this.buttonSize / 2, 497);

    // Background
    const background = new PIXI.Graphics()
      .roundRect(0, 0, this.buttonSize, this.buttonSize, this.buttonSize / 2)
      .fill(0xF6E4DD);

    // Bike
    const bikeRotationContainer = new PIXI.Container();
    bikeRotationContainer.position.set(this.buttonSize / 2, this.buttonSize / 2);

    const bike = new PIXI.Sprite(this.assets.bike);
    bike.setSize(403, 233);
    bike.position.set(0, -370);
    bike.anchor.set(0.5, 0.5);
    bikeRotationContainer.addChild(bike);

    // Scooter
    const scooterRotationContainer = new PIXI.Container();
    scooterRotationContainer.position.set(this.buttonSize / 2, this.buttonSize / 2);
    scooterRotationContainer.rotation = Math.PI * 0.40;

    const scooter = new PIXI.Sprite(this.assets.scooter);
    scooter.setSize(181, 175);
    scooter.position.set(0, -355);
    scooter.anchor.set(0.5, 0.5);
    scooterRotationContainer.addChild(scooter);

    // Animations
    this.transportTimeline = gsap.timeline();
    this.transportTimeline.to(bikeRotationContainer, {
      duration: 20.0,
      rotation: Math.PI * 2,
      repeat: -1,
      ease: 'linear'
    }, 0.0);
    // this.transportTimeline.to(bike.position, {
    //   duration: 0.25,
    //   y: "+=15",
    //   ease: 'sine.inOut',
    //   repeat: -1,
    //   yoyo: true
    // }, 0.0);

    this.transportTimeline.to(scooterRotationContainer, {
      duration: 20.0,
      rotation: Math.PI * 2 + (Math.PI * 0.40),
      ease: 'linear',
      repeat: -1
    }, 0.0);
    // this.transportTimeline.to(scooter.position, {
    //   duration: 0.25,
    //   y: "+=15",
    //   ease: 'sine.inOut',
    //   repeat: -1,
    //   yoyo: true
    // }, 0.0);

    buttonContainer.addChild(background);
    buttonContainer.addChild(bikeRotationContainer);
    buttonContainer.addChild(scooterRotationContainer);
    buttonContainer.addChild(arrow);
    buttonContainer.addChild(buttonTextEN);
    buttonContainer.addChild(buttonTextFR);
  }

  buildAlimentationButton() {
    const buttonContainer = new InteractiveButton((e) => {
      app.switchGame(2);
    }, true, "audio/MAF_Reactif_Bouton_Zone 2.oga");
    buttonContainer.position.set(1168, 1354);
    this.stage.addChild(buttonContainer);

    // Text
    const buttonTextEN = new TranslatableText(this.data.buttons.alimentation_text.en.toUpperCase(), this.buttonTextStyle, "en", this).getText();
    const buttonTextFR = new TranslatableText(this.data.buttons.alimentation_text.fr.toUpperCase(), this.buttonTextStyle, "fr", this).getText();
    buttonTextEN.anchor.set(0.5);
    buttonTextFR.anchor.set(0.5);
    buttonTextEN.position.set(this.buttonSize / 2, this.buttonSize / 2);
    buttonTextFR.position.set(this.buttonSize / 2, this.buttonSize / 2);

    // Background
    const background = new PIXI.Graphics()
      .roundRect(0, 0, this.buttonSize, this.buttonSize, this.buttonSize / 2)
      .fill(0x7ABECC);

    // Arrow
    const arrow = new PIXI.Sprite(this.assets.arrow_right);
    arrow.setSize(50, 30);
    arrow.anchor.set(0.5, 0.5);
    arrow.position.set(this.buttonSize / 2, 497);

    // Onion
    const onionRotationContainer = new PIXI.Container();
    onionRotationContainer.position.set(this.buttonSize / 2, this.buttonSize / 2);
    onionRotationContainer.rotation = -Math.PI * 0.24;

    const onion = new PIXI.Sprite(this.assets.onion);
    onion.setSize(211, 363);
    onion.position.set(-310, -40);
    onion.anchor.set(0.5, 0.5);
    onionRotationContainer.addChild(onion);

    // Corn
    const cornRotationContainer = new PIXI.Container();
    cornRotationContainer.position.set(this.buttonSize / 2, this.buttonSize / 2);

    const corn = new PIXI.Sprite(this.assets.corn);
    corn.setSize(285, 516);
    corn.position.set(285, -60);
    corn.anchor.set(0.5, 0.5);
    cornRotationContainer.addChild(corn);

    // Animations
    this.alimentationTimeline = gsap.timeline();
    this.alimentationTimeline.to(onionRotationContainer.position, {
      duration: 2,
      y: "-=15",
      ease: 'sine.inOut',
      yoyo: true,
      repeat: -1
    }, window.getRandomFloat(0, 0.2));
    this.alimentationTimeline.to(cornRotationContainer.position, {
      duration: 2,
      y: "-=15",
      ease: 'sine.inOut',
      yoyo: true,
      repeat: -1
    }, window.getRandomFloat(0, 0.2));

    buttonContainer.addChild(cornRotationContainer);
    buttonContainer.addChild(background);
    buttonContainer.addChild(onionRotationContainer);
    buttonContainer.addChild(arrow);
    buttonContainer.addChild(buttonTextEN);
    buttonContainer.addChild(buttonTextFR);
  }

  buildNatureButton() {
    const buttonContainer = new InteractiveButton((e) => {
      app.switchGame(3)
    }, true, "audio/MAF_Reactif_Bouton_Zone 3.oga");
    buttonContainer.position.set(2606, 1440);
    this.stage.addChild(buttonContainer);

    // Text
    const buttonTextEN = new TranslatableText(this.data.buttons.nature_text.en.toUpperCase(), this.buttonTextStyle, "en", this).getText();
    const buttonTextFR = new TranslatableText(this.data.buttons.nature_text.fr.toUpperCase(), this.buttonTextStyle, "fr", this).getText();
    buttonTextEN.anchor.set(0.5);
    buttonTextFR.anchor.set(0.5);
    buttonTextEN.position.set(this.buttonSize / 2, this.buttonSize / 2);
    buttonTextFR.position.set(this.buttonSize / 2, this.buttonSize / 2);

    // Arrow
    const arrow = new PIXI.Sprite(this.assets.arrow_right);
    arrow.setSize(50, 30);
    arrow.anchor.set(0.5, 0.5);
    arrow.position.set(this.buttonSize / 2, 497);

    // Background
    const background = new PIXI.Graphics()
      .roundRect(0, 0, this.buttonSize, this.buttonSize, this.buttonSize / 2)
      .fill(0xA4CEA2);

    // Tree 1
    const tree1RotationContainer = new PIXI.Container();
    tree1RotationContainer.rotation = Math.PI * 0.075;
    tree1RotationContainer.position.set(this.buttonSize / 2, this.buttonSize / 2);

    const tree1 = new PIXI.Sprite(this.assets.tree1);
    tree1.setSize(297, 445);
    tree1.position.set(0, -80);
    tree1.anchor.set(0.5, 1);
    tree1RotationContainer.addChild(tree1);

    // Tree 2
    const tree2RotationContainer = new PIXI.Container();
    tree2RotationContainer.rotation = Math.PI * 0.29;
    tree2RotationContainer.position.set(this.buttonSize / 2, this.buttonSize / 2);

    const tree2 = new PIXI.Sprite(this.assets.tree2);
    tree2.setSize(309, 370);
    tree2.position.set(67, -224);
    tree2.anchor.set(0.5, 1);
    tree2RotationContainer.addChild(tree2);

    // Animations
    this.natureTimeline = gsap.timeline();
    this.natureTimeline.to(tree1.scale, {
      duration: 3.5,
      x: 1.1,
      y: 1.1,
      ease: 'sine.inOut',
      yoyo: true,
      repeat: -1
    }, window.getRandomFloat(0, 0.2));
    this.natureTimeline.to(tree2.scale, {
      duration: 3.5,
      x: 1.1,
      y: 1.1,
      ease: 'sine.inOut',
      yoyo: true,
      repeat: -1
    }, window.getRandomFloat(0, 0.2));

    buttonContainer.addChild(tree1RotationContainer);
    buttonContainer.addChild(background);
    buttonContainer.addChild(tree2RotationContainer);
    buttonContainer.addChild(arrow);
    buttonContainer.addChild(buttonTextEN);
    buttonContainer.addChild(buttonTextFR);
  }

  activate() {
    // Enable render
    this.start();
    this.ticker.start();
    this.soundscape.start();

    this.languageSwitcher.enable();
    this.languageSwitcher.disableHome();

    // TODO: start the timelines here so they are moving while fading in view
  }

  deactivate() {
    // Disable render
    this.stop();
    this.ticker.stop();
    this.soundscape.stopAll()

    this.languageSwitcher.disable();

    // TODO: Pause all the timelines so the game isn't doing a thing while not on screen
  }

  begin(){
    // Game is ready to go, on screen, and animations have started
    // TODO: enable actions here
    this.fadeOutOverlay();
  }

  progress(ticker) {
    // console.log("progress IdleScreen");
  }

  reset() {
    // TODO: Pause all the timelines and reset them
    this.fadeOverlayLayer.alpha = 1;
  }
}
